/** Shop catalog + Razorpay checkout for Full Course / HD pack. */

import { FULL_COURSE_CHARGE_INR } from "./regionalPricing";



export type ShopProductId = "full_course" | "hd_sample_pack";



export type ShopProduct = {

  id: ShopProductId;

  title: string;

  amountInr: number;

  blurb: string;

  available: boolean;

};



export const SHOP_PRODUCTS: Record<ShopProductId, ShopProduct> = {

  full_course: {

    id: "full_course",

    title: "Full Course Unlock",

    amountInr: FULL_COURSE_CHARGE_INR,

    blurb: "Unlock every lesson after the 5 free ones, all exams, practice packs, the full campaign, and permanently remove ads.",

    available: true,

  },

  hd_sample_pack: {

    id: "hd_sample_pack",

    title: "HD Piano Sample Pack",

    amountInr: 199,

    blurb: "Richer multi-velocity piano samples (downloads when pack ships).",

    available: false,

  },

};



export const RAZORPAY_KEY_ID =

  (import.meta.env.VITE_RAZORPAY_KEY_ID as string | undefined) || "rzp_live_TEa1ePRwkf16Xx";



export const CHECKOUT_SITE = "https://ultimate-piano-tutor.web.app";



declare global {

  interface Window {

    Razorpay?: new (options: Record<string, unknown>) => { open: () => void };

    Capacitor?: {

      isNativePlatform?: () => boolean;

      getPlatform?: () => string;

    };

  }

}



export function loadRazorpayScript(): Promise<void> {

  if (window.Razorpay) return Promise.resolve();

  return new Promise((resolve, reject) => {

    const s = document.createElement("script");

    s.src = "https://checkout.razorpay.com/v1/checkout.js";

    s.async = true;

    s.onload = () => resolve();

    s.onerror = () => reject(new Error("Could not load Razorpay checkout."));

    document.head.appendChild(s);

  });

}



export function isElectronShell(): boolean {

  return /Electron/i.test(navigator.userAgent);

}



/** Desktop Electron or Capacitor native shell — must not host native Razorpay. */

export function isNativeShell(): boolean {

  if (isElectronShell()) return true;

  try {

    return Boolean(window.Capacitor?.isNativePlatform?.());

  } catch {

    return false;

  }

}


